import 'polyfills';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, applyRouterMiddleware, browserHistory, useRouterHistory } from 'react-router';
import useScroll from 'react-router-scroll';
import trackingMiddleware from 'common/middlewares/trackingMiddleware';
import { syncHistoryWithStore } from 'react-router-redux';
import { addLocaleData } from 'react-intl';
import config from 'config';
import { docReady } from 'lib/ui';
import configureStore from 'store';
import createRoutes from './routes';
import ComponentDataContainer from 'common/ComponentDataContainer';
import IntlProvider from 'common/IntlProvider';
import { init } from 'lib/omniture';
import { analyticsConstantsSelector } from 'common/selectors/analyticsSelectors';
import { ssrSelector } from 'common/selectors/appSelector';
import { appRendered } from 'common/actions/appActions';

if (process.env.NODE_ENV !== 'production' && process.env.PERF_DEBUG === 'true') {
    const { whyDidYouUpdate } = require('why-did-you-update');
    whyDidYouUpdate(React);
}

// since we are using the same bundle for qa and prod, we need to define the "publicPath"
// for webpack at runtime.  The alternative is building a bundle for each environment
// http://webpack.github.io/docs/configuration.html#output-publicpath
/* eslint-disable */
if (window.watchGlobals) {
    __webpack_public_path__ = `${window.location.protocol === 'https:' ? window.watchGlobals.secureCdnPath : window.watchGlobals.cdnPath}/`;
}
/* eslint-enable */

const initialState = window && window.__INITIAL_STATE__;
const localeData = window && window.ReactIntlLocaleData;
const enhancedBrowserHistory = useRouterHistory(() => browserHistory)({
    basename: '/watch'
});

const store = configureStore(initialState, enhancedBrowserHistory, [trackingMiddleware]);
const history = syncHistoryWithStore(enhancedBrowserHistory, store);
const { dispatch } = store;

function loadActionsRouterMiddleware(props = {}) {
    return {
        renderRouterContext: (child, routerProps) => (
            <ComponentDataContainer routerProps={routerProps} {...props}>{ child }</ComponentDataContainer>
        )
    };
}

function renderApp() {
    const renderWithMiddleware = applyRouterMiddleware(
        useScroll(),
        loadActionsRouterMiddleware({
            dispatch
        })
    );
    const routes = createRoutes();
    const appContainer = document.getElementById(config.uid);
    const state = store.getState();
    const { app: { lang } } = state;
    const ssr = ssrSelector(state);
    const analyticsConstants = analyticsConstantsSelector(state);

    if (localeData && localeData[lang]) {
        addLocaleData(localeData[lang]);
    }

    init(analyticsConstants);

    if (appContainer) {
        render(
            <Provider store={store}>
                <IntlProvider>
                    <Router
                        history={history}
                        render={renderWithMiddleware}
                        lang={lang}
                        ssr={ssr}
                    >
                        { routes }
                    </Router>
                </IntlProvider>
            </Provider>,
            appContainer,
            () => {
                dispatch(appRendered());
            }
        );
    }
}

window._reactInMem = true;
// Overwriting from espn-head.js to enable error logging for Beta period
if (window.newrelic && config.isBeta) {
    window.newrelic.setErrorHandler(() => (false));
}

docReady(() => {
    if (!window.Intl) {
        import(/* webpackChunkName: "polyfill-intl" */ 'intl')
            .then(renderApp)
            .catch(() => {
                // console.error(err);
                renderApp();
            });
    } else {
        renderApp();
    }
});

window.debug = window.debug || {};
window.debug.setLevel = () => {};



// WEBPACK FOOTER //
// ./app/webapp/client.js